import { useEffect, useRef, useState } from "react"
import { Grid, GridItem, Tag, VStack } from "@chakra-ui/react"
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api"
import { roundToDP } from "@hydrologiq/shared/test/math"
import "./Map.css"

const containerStyle = {
  width: "100%",
  height: "100%",
}

export type LocationMarker = {
  location: Location
  title: string
  privateMode?: string
  tag?: React.ReactNode
}

export interface Location {
  lat: number
  long: number
}

export interface LatLong {
  lat: number
  lng: number
}

export interface MapProps {
  focusMarker?: LocationMarker
  locationChange?: (location: Location) => void
  zoom?: number
  markers?: LocationMarker[]
  apiKey: string
  showMarkers?: boolean
  height?: { base: string; sm?: string; md?: string } | string
  width?: string
  maxWidth?: string
  maxHeight?: string
  paddingBottom?: number
}

const center: Location = {
  lat: 54.97101,
  long: -2.45682,
}

function Map(props: MapProps) {
  const {
    focusMarker,
    locationChange,
    zoom = 3,
    apiKey,
    showMarkers = false,
    height = "290px",
    width = "290px",
    maxWidth,
    maxHeight,
    paddingBottom = 5,
  } = props
  let { markers = [] } = props
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: apiKey,
    language: "en",
  })

  const mapRef = useRef<GoogleMap>(null)
  const [loc, setLoc] = useState<Location>(focusMarker?.location || center)

  useEffect(() => {
    loc && locationChange && locationChange(loc)
  }, [loc])

  // useEffect(() => {
  //   if (focusMarker?.location && (focusMarker.location.lat !== loc.lat || focusMarker.location.long !== loc.long))
  //     setLoc(focusMarker.location)
  // }, [focusMarker])

  // useEffect(() => {
  //   if (loc !== focusMarker?.location && loc !== center) setLoc((focusMarker && focusMarker.location) || center)
  // }, [focusMarker])

  // useEffect(() => {
  //   if (mapRef.current) {
  //     const instance = mapRef.current.getInstance()
  //     instance?.setCenter({
  //       lat: focusMarker?.location.lat ?? 54.9753147,
  //       lng: focusMarker?.location.long ?? -2.269908,
  //     })
  //     instance?.setZoom(zoom)
  //   }
  // }, [focusMarker])

  return (
    <>
      <VStack maxHeight={maxHeight} maxWidth={maxWidth} height={height} width={width} pb={paddingBottom}>
        {isLoaded && (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={{
              lat: (focusMarker?.location || loc)?.lat ?? 54.9753147,
              lng: (focusMarker?.location || loc)?.long ?? -2.269908,
            }}
            zoom={zoom}
            options={{ streetViewControl: false, mapTypeControl: false, fullscreenControl: false }}
            onClick={(ev: google.maps.MapMouseEvent) => {
              if (ev.latLng) {
                setLoc({ lat: roundToDP(ev.latLng.lat(), 5), long: roundToDP(ev.latLng.lng(), 5) })
              }
            }}
            ref={mapRef}
          >
            {(focusMarker ? [focusMarker, ...markers] : markers).map((marker, index) => (
              <Marker
                position={{ lat: marker.location.lat, lng: marker.location.long }}
                title={marker.title}
                label={{ text: `${index + 1}` }}
                key={`${marker.location.lat}-${marker.location.long}-${index}`}
              />
            ))}
          </GoogleMap>
        )}
        {showMarkers && markers.length > 0 && (
          <Grid templateColumns={`repeat(2, 1fr)`}>
            {markers.map((marker, index) => (
              <GridItem key={`${marker.location.lat}-${marker.location.long}-${index}`}>
                <Tag.Root
                  minWidth={"200px"}
                  background={"none"}
                  className={marker.privateMode ? marker.privateMode : ""}
                >
                  {index + 1} - {marker.tag ?? marker.title}
                </Tag.Root>
              </GridItem>
            ))}
          </Grid>
        )}
      </VStack>
    </>
  )
}

export default Map
